<template>
    <div>
        <v-select
                v-model="selectedTrainingCenter"
                :items="trainingCenters"
                item-text="name"
                item-value="id"
                :label="label"
                :error-messages="errorMessages"
                required
                @change="emitSelected"
                return-object
        ></v-select>
    </div>
</template>

<script>
    import TRAINING_CENTERS from "../../graphql/TrainingCentersAll.gql";

    export default {
        props: {
            value: {
                type: [String],
                default: "",
            },
            label: {
                type: String,
                default: 'Venue *',
            },
            errorMessages: {
                type: Array,
                default: ()=>{return []}
            },
        },
        data() {
            return {
                selectedTrainingCenter: {id: this.value},
            }
        },
        apollo: {
            trainingCenters: {
                query: TRAINING_CENTERS,
                update: data => data.trainingCenters
            }
        },

        methods: {
            emitSelected(item) {
                this.$emit('input', item.id);
                this.$emit('selected', item)
            }
        },
    }
</script>
